import { defineMessages } from 'react-intl';

const prefix = 'changeSubscriptionDialog';

export const i18n = defineMessages({
    title: {
        id: `${prefix}.title`,
        defaultMessage: 'Change Subscription status',
    },
    activateDescription: {
        id: `${prefix}.activateDescription`,
        defaultMessage: 'Are you sure you want to activate this subscription?',
    },
    deactivateDescription: {
        id: `${prefix}.deactivateDescription`,
        defaultMessage: 'Are you sure you want to deactivate this subscription?',
    },
    changeError: {
        id: `${prefix}.changeError`,
        defaultMessage: 'Failed to change subscription status',
    },
    activateButtonText: {
        id: `${prefix}.activateButtonText`,
        defaultMessage: 'Activate',
    },
    deactivateButtonText: {
        id: `${prefix}.deactivateButtonText`,
        defaultMessage: 'Deactivate',
    },
    cancelButtonText: {
        id: `${prefix}.cancelButtonText`,
        defaultMessage: 'Cancel',
    },
});
